import { createTranslations } from '@npco/utils-translations'

export const peopleListItemTranslations = createTranslations({
  listItemAriaLabel: '{firstName} {lastName} Contact Item',
})
